import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpParams,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { take, exhaustMap, tap } from 'rxjs/operators';

import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.authService.user.pipe(
      take(1),
      exhaustMap((user) => {
        if (!user) {
          return next.handle(req);
        }
        let modifiedReq = req.clone();
        if (req.url != environment.apiUrl + '/restore') {
          modifiedReq = req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + user.token,
            },
            //headers: new HttpHeaders().set('Authorization', 'Bearer ' + user.token),
          });
        }
        return next.handle(modifiedReq).pipe(
          tap(
            () => {
              // update the is authed cookie
              var nowExp = new Date();
              var time = nowExp.getTime();
              var expireTime = time + 1000 * 3600;

              nowExp.setTime(expireTime);
              const expTime = new Date(nowExp);
              this.cookieService.set(
                'appAuthed',
                new Date().toISOString(),
                expTime,
                '/'
              );
              //this.authService.clearAutoLogout();

             // this.authService.autoLogout(3600 * 1000);
            },
            (err: any) => {
              if (err instanceof HttpErrorResponse) {
                if (err.status !== 401) {
                  return;
                }
                // console.log('401 FOUND');
                // cop out for now..
                location.reload();
              }
            }
          )
        );
      })
    );
  }
}
